import { render, staticRenderFns } from "./VersionEditor.vue?vue&type=template&id=1dfee553&scoped=true"
import script from "./VersionEditor.vue?vue&type=script&lang=js"
export * from "./VersionEditor.vue?vue&type=script&lang=js"
import style0 from "./VersionEditor.vue?vue&type=style&index=0&id=1dfee553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfee553",
  null
  
)

export default component.exports